import { render, staticRenderFns } from "./galaxy-telegram-search.vue?vue&type=template&id=6c2e160e&"
import script from "./galaxy-telegram-search.vue?vue&type=script&lang=js&"
export * from "./galaxy-telegram-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports